import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice=createSlice({
    name:"dashboard",
    initialState:{
        carbonEmissionAvoided:"",
        recyclePackaging:"",
        carbonReported:"",
        supplierSubmittedGoals:"",
        selectedMarkets:[],
        supplierName:""
    },
    reducers:{
        setCarbonEmissionAvoided(state,action){
            state.carbonEmissionAvoided=action.payload;
        },
        setRecyclePackaging(state,action){
            state.recyclePackaging=action.payload;
        },
        setCarbonReported(state,action){
            state.carbonReported=action.payload;
        },
        setSupplierSubmittedGoals(state,action){
            state.supplierSubmittedGoals=action.payload;
        },
        setSelectedMarkets(state, action) {
            state.selectedMarkets = action.payload;
        },
        setSupplierName(state, action) {
            state.supplierName = action.payload;
        }
    }
})

export const {setCarbonEmissionAvoided,setCarbonReported,setRecyclePackaging,setSupplierSubmittedGoals,setSelectedMarkets,setSupplierName} = dashboardSlice.actions;
export default dashboardSlice.reducer;